import type { SendPaymentBodyType } from '@/types';

// Flattens `{ value, isValid }` wrapper fields to their `value`; arrays are comma-joined.
const flattenFormBody = (body: SendPaymentBodyType): { [key: string]: any } => {
  const formatedBody: { [key: string]: any } = { ...body };
  Object.keys(formatedBody).forEach((property: string) => {
    if (Array.isArray(formatedBody[property])) {
      formatedBody[property] = formatedBody[property].join(',');
    } else if (formatedBody[property] && typeof formatedBody[property] === 'object') {
      formatedBody[property] = formatedBody[property].value;
    }
  });
  return formatedBody;
};

export const formatSendPaymentBody = (body: SendPaymentBodyType) => {
  const formatedBody = flattenFormBody(body);
  formatedBody.Amount = parseFloat(formatedBody.Amount).toFixed(2);
  formatedBody.CreditWallet = formatedBody.CreditWallet[0];
  formatedBody.DebitWallet = formatedBody.DebitWallet[0];
  formatedBody.originTransaction =
    formatedBody.originTransaction?.length > 0 ? formatedBody.originTransaction[0] : null;
  formatedBody.Message = formatedBody.Message !== '' ? formatedBody.Message : null;

  return formatedBody;
};

export const formatRefundPaymentBody = (body: SendPaymentBodyType, transactionId: string) => {
  const formatedBody = flattenFormBody(body);
  return {
    AmountToRefund: parseFloat(formatedBody.Amount).toFixed(2),
    TransactionId: parseInt(transactionId, 10),
    Comment: formatedBody.Message !== '' ? formatedBody.Message : null,
    Password: formatedBody.Password,
    language: formatedBody.language
  };
};
